import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { themeIcon } from "../../../asset";
import { uiAction } from "../../../store/ui-gemini";
import styles from "./Sidebar.module.css";

const AdminSidebar = () => {
  const dispatch = useDispatch();
  const isAdminSidebarLong = useSelector(
    (state) => state.ui.isAdminSidebarLong
  );

  const sideBarWidthHandler = () => {
    dispatch(uiAction.toggleAdminSidebar());
  };

  const icon = themeIcon();
  const sideBarWidthClass = isAdminSidebarLong
    ? "side-bar-long"
    : "side-bar-sort";

  return (
    <div
      className={`${styles["admin-sidebar-main"]} ${styles[sideBarWidthClass]}`}
    >
      <div className={styles["menu-icon"]} onClick={sideBarWidthHandler}>
        <img src={icon.menuIcon} className="!size-9" alt="menu icon"></img>
      </div>

      <div className={styles["settings-section"]}>
        <div className={styles["oveview"]}>
          <Link
            to="user"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {/* <img className="icon" src={icon.helpIcon} alt="help icon"></img> */}
            {isAdminSidebarLong && <p>Users</p>}
          </Link>
        </div>{" "}
        <div className={styles["oveview"]}>
          <Link
            to="plan"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {isAdminSidebarLong && <p>Plans</p>}
          </Link>
        </div>
        <div className={styles["user"]}>
          <Link
            to="subscription"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {/* <img className="icon" src={icon.helpIcon} alt="help icon"></img> */}
            {isAdminSidebarLong && <p>Subscriptions</p>}
          </Link>
        </div>
        <div className={styles["user"]}>
          <Link
            to="transaction"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {/* <img className="icon" src={icon.helpIcon} alt="help icon"></img> */}
            {isAdminSidebarLong && <p>Transaction</p>}
          </Link>
        </div>
        <div className={styles["user"]}>
          <Link
            to="alert-content"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {/* <img className="icon" src={icon.helpIcon} alt="help icon"></img> */}
            {isAdminSidebarLong && <p>Alert Content</p>}
          </Link>
        </div>
        <div className={styles["user"]}>
          <Link
            to="email-mkt"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {/* <img className="icon" src={icon.helpIcon} alt="help icon"></img> */}
            {isAdminSidebarLong && <p>Email Marketing</p>}
          </Link>
        </div>
        <div className={styles["user"]}>
          <Link
            to="es-index"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {/* <img className="icon" src={icon.helpIcon} alt="help icon"></img> */}
            {isAdminSidebarLong && <p>Index ElasticSearch</p>}
          </Link>
        </div>
        <div className={styles["user"]}>
          <Link
            to="coupon"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {/* <img className="icon" src={icon.helpIcon} alt="help icon"></img> */}
            {isAdminSidebarLong && <p>Coupon</p>}
          </Link>
        </div>
        <div className={styles["user"]}>
          <Link
            to="community/posts"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {isAdminSidebarLong && <p>Community Posts</p>}
          </Link>
        </div>
        <div className={styles["user"]}>
          <Link
            to="community/comments"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {isAdminSidebarLong && <p>Community Comments</p>}
          </Link>
        </div>
        <div className={styles["user"]}>
          <Link
            to="slide"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {/* <img className="icon" src={icon.helpIcon} alt="help icon"></img> */}
            {isAdminSidebarLong && <p>Slides</p>}
          </Link>
        </div>

        <div className={styles["user"]}>
          <Link
            to="video"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {isAdminSidebarLong && <p>Videos</p>}
          </Link>
        </div>

        <div className={styles["user"]}>
          <Link
            to="courses"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {/* <img className="icon" src={icon.helpIcon} alt="help icon"></img> */}
            {isAdminSidebarLong && <p>Courses</p>}
          </Link>
        </div>

        <div className={styles["user"]}>
          <Link
            to="prompts"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {isAdminSidebarLong && <p>Prompts</p>}
          </Link>
        </div>

        <div className={styles["user"]}>
          <Link
            to="status/incidents"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {isAdminSidebarLong && <p>Status — Incidents</p>}
          </Link>
        </div>

        <div className={styles["user"]}>
          <Link
            to="status/components"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {isAdminSidebarLong && <p>Status — Components</p>}
          </Link>
        </div>

        <div className={styles["user"]}>
          <Link
            to="status/subscribers"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {isAdminSidebarLong && <p>Status — Subscribers</p>}
          </Link>
        </div>

        <div className={styles["user"]}>
          <Link
            to="feedback"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {isAdminSidebarLong && <p>Feedback</p>}
          </Link>
        </div>

        <div className={styles["user"]}>
          <Link
            to="setting"
            className="border-b w-full p-2 rounded-md hover:bg-slate-300 mr-2"
          >
            {/* <img className="icon" src={icon.helpIcon} alt="help icon"></img> */}
            {isAdminSidebarLong && <p>Settings</p>}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
